module.exports = __webpack_public_path__ + "static/img/videobg.ead3007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videobg.jpg
// module id = x/uP
// module chunks = 0